import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'GET_BLOCKED_EMAILS',
	'UNBLOCK_EMAIL',
);
